// src/components/admin/UserLayout.js
import React, { useState } from "react";
import { Box, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import UserSidebar from "./UserSidebar";
import UserNavbar from "./UserNavbar";

const drawerWidth = 240;
const collapsedWidth = 70;

const UserLayout = () => {
  const [isOpen, setIsOpen] = useState(true);

  const handleDrawerToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box sx={{ 
      display: "flex", 
      flexDirection: "row-reverse",
      minHeight: "100vh",
      backgroundColor: "#f8fafc"
    }}>
      {/* ✅ Sidebar */}
      <UserSidebar isOpen={isOpen} handleDrawerToggle={handleDrawerToggle} />

      {/* ✅ المحتوى */}
      <Box
        sx={{
          flexGrow: 1,
          transition: "margin 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          mr: isOpen ? `${drawerWidth}px` : `${collapsedWidth}px`,
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        }}
      >
        <UserNavbar isOpen={isOpen} drawerWidth={drawerWidth} collapsedWidth={collapsedWidth} />
        <Toolbar sx={{ minHeight: "70px" }} />
        <Box sx={{ 
          p: 4,
          background: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(10px)",
          borderRadius: "20px 0 0 0",
          minHeight: "calc(100vh - 70px)",
          boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)"
        }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default UserLayout;
